var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAskSeller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.747,
    height: 13.997,
    viewBox: "0 0 13.747 13.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#398af5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16157 -50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16157 50)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.874,0a6.855,6.855,0,0,1,6.874,6.874,7.018,7.018,0,0,1-1.318,4.1l.5,3.027-3.455-.748a7.179,7.179,0,0,1-2.6.5A6.874,6.874,0,0,1,6.874,0Zm0,.89a5.983,5.983,0,1,0,0,11.967A6.2,6.2,0,0,0,9.4,12.323l2.422.534-.356-2.137A5.993,5.993,0,0,0,6.874.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M133,94.208a2.137,2.137,0,1,1,3.027,1.994.748.748,0,0,0-.427.712v.178h-.926v-.178a1.723,1.723,0,0,1,.962-1.531,1.292,1.292,0,0,0,.748-1.175,1.248,1.248,0,1,0-2.493,0Z",
    transform: "translate(-128.263 -88.723)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.797,
    cy: 0.797,
    r: 0.797,
    transform: "translate(6.374 8.885)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskSeller);
export default __webpack_public_path__ + "static/media/ask-seller.a08d674d464b34fe08d33ab38766b15f.svg";
export { ForwardRef as ReactComponent };